<template>
    <div class="header-analytics">
        <h1 class="header-analytics__heading">Analitikler</h1>
        <p class="header-analytics__desc">Öğrenimine yönelik verileri incele</p>
    </div>
</template>
<script>
    export default {};
</script>
<style scoped src="@/css/components/header-analytics.css"></style>